import { fontFamilies } from '../../../glassConsts';
import React from 'react';
import { useConfig } from '../../ConfigContext';
import { designSlides } from '../Carousel/carouselData';

const ClassicControls = () => {
  const { general, size } = useConfig();

  return (
    <>
      <div
        style={{
          fontFamily: fontFamilies[general.font],
          fontSize: general.orientationHorizontal
            ? size.height / 24
            : size.height / 38,
          fontWeight: 'bold',
          color: general.color,
          textAlign: 'center',
          textShadow: '0 2px 8px rgba(0,0,0,0.15)',
          whiteSpace: general.mainTextBreak ? 'pre-line' : 'normal',
          marginTop: 20,
          marginLeft: 4,
          wordBreak: 'break-word',
        }}
      >
        {general.mainText.length < 1
          ? 'Anet + Lukáš'
          : general.mainTextBreak && general.mainText.includes(' ')
            ? general.mainText.replace(' ', '\n')
            : general.mainText}
      </div>
      {general.hasSecondaryText && (
        <div
          style={{
            fontFamily: fontFamilies[general.font],
            fontSize: general.orientationHorizontal
              ? size.height / 30
              : size.height / 50,
            color: general.color,
            opacity: 0.75,
            textAlign: 'center',
            marginTop: 1,
            wordBreak: 'break-word',
          }}
        >
          {general.secondaryText.length < 1
            ? '1.2.2020'
            : general.secondaryText}
        </div>
      )}
    </>
  );
};

export default ClassicControls;
